import { USERS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const usersApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation({
			query: (data) => ({
				url: `${USERS_URL}/auth`,
				method: 'POST',
				body: data,
			}),
			keepUnusedDataFor: 5,
		}),
		register: builder.mutation({
			query: (data) => ({
				url: `${USERS_URL}`,
				method: 'POST',
				body: data,
			}),
		}),
		createUser: builder.mutation({
			query: (data) => ({
				url: `${USERS_URL}/create`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Users'],
		}),
		logout: builder.mutation({
			query: () => ({
				url: `${USERS_URL}/logout`,
				method: 'POST',
			}),
		}),
		profile: builder.mutation({
			query: (data) => ({
				url: `${USERS_URL}/profile`,
				method: 'PUT',
				body: data,
			}),
		}),
		getUsers: builder.query({
			query: () => ({
				url: USERS_URL,
			}),
			providesTags: ['Users'],
			keepUnusedDataFor: 5,
		}),
		getUsersByTenant: builder.query({
			query: () => ({
				url: `${USERS_URL}/tenant`,
			}),
			providesTags: ['Users'],
			keepUnusedDataFor: 5,
		}),
		deleteUser: builder.mutation({
			query: (userId) => ({
				url: `${USERS_URL}/${userId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Users'],
		}),
		getUserDeleteEligibility: builder.query({
			query: (userId) => ({
				url: `${USERS_URL}/${userId}/delete-eligibility`,
			}),
			providesTags: (result, error, userId) => [{ type: 'Users', id: `delete-eligibility-${userId}` }],
			keepUnusedDataFor: 5,
		}),
		migrateSaleUser: builder.mutation({
			query: ({ userId, toUserId, dryRun }) => ({
				url: `${USERS_URL}/${userId}/migrate-sale`,
				method: 'POST',
				body: { toUserId, dryRun },
			}),
			invalidatesTags: (result, error, arg) =>
				arg?.dryRun
					? []
					: ['Users', { type: 'Users', id: `delete-eligibility-${arg.userId}` }, { type: 'Users', id: `migration-jobs-${arg.userId}` }],
		}),
		getUserMigrationJobs: builder.query({
			query: (userId) => ({
				url: `${USERS_URL}/${userId}/migration-jobs`,
			}),
			providesTags: (result, error, userId) => [{ type: 'Users', id: `migration-jobs-${userId}` }],
			keepUnusedDataFor: 5,
		}),
		getUserDetails: builder.query({
			query: (userId) => ({
				url: `${USERS_URL}/${userId}`,
			}),
			keepUnusedDataFor: 5,
		}),
		updateUser: builder.mutation({
			query: (data) => ({
				url: `${USERS_URL}/${data.userId}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['Users'],
		}),
		getSaleUsers: builder.query({
			query: (arg) => ({
				url: `${USERS_URL}/sale`,
				...(arg?.scope ? { params: { scope: arg.scope } } : {}),
			}),
			providesTags: ['Users'],
			keepUnusedDataFor: 5,
		}),
		getAssistantUsers: builder.query({
			query: (arg) => ({
				url: `${USERS_URL}/assistant`,
				...(arg?.scope ? { params: { scope: arg.scope } } : {}),
			}),
			providesTags: ['Users'],
			keepUnusedDataFor: 5,
		}),
		getUserProfile: builder.query({
			query: () => ({
				url: `${USERS_URL}/profile`,
			}),
			keepUnusedDataFor: 0,
		}),
	}),
});

export const {
	useLoginMutation,
	useLogoutMutation,
	useRegisterMutation,
	useCreateUserMutation,
	useProfileMutation,
	useGetUsersQuery,
	useDeleteUserMutation,
	useGetUserDeleteEligibilityQuery,
	useMigrateSaleUserMutation,
	useGetUserMigrationJobsQuery,
	useGetUserDetailsQuery,
	useUpdateUserMutation,
	useGetUsersByTenantQuery,
	useGetSaleUsersQuery,
	useGetAssistantUsersQuery,
	useGetUserProfileQuery,
} = usersApiSlice;
